module.exports = __webpack_public_path__ + "static/img/10.2e78ae7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/10.jpg
// module id = gwRI
// module chunks = 0